var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBordercruve2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1005_6964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-752.599 23.5385C-740.939 23.5385 -731.463 14.0522 -731.463 2.40108C-731.463 1.07261 -730.391 0 -729.062 0H3.05231C4.38069 0 5.45324 1.07261 5.45324 2.40108C5.45324 14.0522 14.9389 23.5385 26.5991 23.5385C27.9275 23.5385 29 24.6111 29 25.9396V526.06C29 527.389 27.9275 528.462 26.5991 528.462C14.9389 528.462 5.45324 537.948 5.45324 549.599C5.45324 550.927 4.38069 552 3.05231 552H-729.062C-730.391 552 -731.463 550.927 -731.463 549.599C-731.463 537.948 -740.939 528.462 -752.599 528.462C-753.927 528.462 -755 527.389 -755 526.06V25.9396C-755 24.6111 -753.927 23.5385 -752.599 23.5385ZM-750.198 523.768C-737.81 524.909 -727.911 534.809 -726.769 547.198H0.759628C1.89121 534.809 11.7901 524.909 24.1883 523.768V28.2422C11.7901 27.1007 1.89121 17.2012 0.759628 4.812H-726.769C-727.911 17.2012 -737.81 27.1007 -750.198 28.2422V523.768Z",
    fill: "#C4944D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1005_6964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "matrix(-1 0 0 1 29 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBordercruve2);
export default __webpack_public_path__ + "static/media/bordercruve2.46ab00f12b8b9e8540ccafafeb9da2ae.svg";
export { ForwardRef as ReactComponent };